var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"txt",rawName:"v-txt",value:(4 * 5),expression:"4 * 5"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }